<template>
  <div class="component__location">
    <div class="location__icon"></div>
    <div class="location__curt">{{ provinceEnum[areaId] || '其它' }}</div>
    <div class="location__regions">
      <div class="regions__menu">
        <div class="regions__menu-items">
          <span class="item" :class="{ selected: item.id == areaId }" v-for="(item, index) of provinceList"
            :key="index" @click="clickToChangeProvinceIdFn(item)">{{ item.alias }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { provinceIdEnum, invertProvinceIdEnum } from './define.js'
import jsCookie from 'js-cookie'

// 老版本商城兼容
import { mapMutations } from 'vuex'

export default {
  data() {
    return {
      provinceList: [],
      areaId: 100
    }
  },
  computed: {
    provinceEnum () {
      const data = {}
      for (let item of this.provinceList) {
        data[item.id] = item.alias
      }
      return data
    },
  },
  mounted () {
    this.requestProvinceDataFn()

    if (jsCookie.get('stu_area_id')) {
      const areaId = +jsCookie.get('stu_area_id')
      this.areaId = provinceIdEnum[areaId] || 100
    }

  },
  watch: {
    areaId: {
      immediate: true,
      handler (id) {
        this.$emit('change', id)
        // 下面的逻辑是在切换省份的时候，不同的省份的年级模式不同
        // 有的省份年级多，有的少，所以要替换路由内的相关参数
        let userGrade = +jsCookie.get('userGrade') || 4
        let grade = +this.$route.query.gradeId || userGrade
        if (id === 9 && grade === 7) {
          this.$router.replace({
            name: this.$route.name,
            query: { ...this.$route.query, switch_grade: 26, gradeId: 26 }
          })
        }
        if (id !== 9 && id !== 100 && grade === 26) {
          this.$router.replace({
            name: this.$route.name,
            query: { ...this.$route.query, switch_grade: 7, gradeId: 7 }
          })
        }
      }
    }
  },
  methods: {
    ...mapMutations({
      setXareaid :'SET_XAREAID'
    }),
    async requestProvinceDataFn () {
      try {
        const { data } = await axios.get('https://mall.xueersi.com/province', {
          params: {
            device: 1,
          }
        })
        this.provinceList = data
      } catch (error) {

      }
    },
    clickToChangeProvinceIdFn (item) {
        this.setXareaid(item.id)
        this.areaId = item.id
        jsCookie.set('stu_area_id', invertProvinceIdEnum[item.id] || 100, {
          domain: '.xueersi.com', expires: 3 * 365
        })
    },
  },
}
</script>

<style lang="scss">
.component__location {
  position: relative;
  display: flex;
  align-items: center;
  height: 36px;
  cursor: pointer;
}

.component__location .location__icon {
  width: 10px;
  background-image: url('./icon.png');
  height: 13px;
  background-size: cover;
  margin-right: 4px;
}

.component__location .location__curt {
  color: #333333;
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
}

.component__location:hover {
  .location__regions {
    display: block;
  }
}

.component__location .location__regions {
  width: 266px;
  position: absolute;
  left: 0;
  top: 23px;
  z-index: 20;
  padding-top: 12px;
  display: none;

  .regions__menu {
    position: relative;
    &::before {
      content: '';
      position: absolute;
      left: 20px;
      top: -5px;
      width: 10px;
      transform: rotate(45deg);
      height: 10px;
      background-color: #ffffff;
      box-shadow: 0px -1px 4px rgba($color: #000000, $alpha: 0.1);
    }
    &::after {
      content: "";
      position: absolute;
      left: 20px;
      top: -4px;
      width: 10.5px;
      transform: rotate(45deg);
      height: 10.5px;
      background-color: #ffffff;
      z-index: 10;
    }
  }

  .regions__menu-items {
    background-color: #ffffff;
    box-shadow: 0 0 5px 2px rgba(0, 0, 0, 0.05);
    border-top: none;
    padding: 10px 8px;
    border: 1px solid #f1f1f1;
    border-radius: 4px;
    overflow: hidden;
  }

  .regions__menu-items .item {
    float: left;
    display: block;
    font-weight: 400;
    font-size: 12px;
    color: #333333;
    width: 52px;
    height: 25px;
    line-height: 25px;
    text-align: center;
    padding: 0;
    margin-right: 10px;
    &:hover, &.selected {
      color: #f13232;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ./src/components/xesMallSearch/components/location/location.vue